import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {FileValidationError} from '../../lib/validateFile';

type Step = 'chooseFile' | 'validateFile' | 'uploadFile' | 'errors' | 'done';

interface ImportModalState {
  step: Step;
  selectedFile: File | null;
  remoteFileLocation: {
    url: string;
    cloudStorageBucket: string;
    cloudStorageFilePath: string;
  } | null;
  fileValidationErrors: Set<FileValidationError> | null;
}

interface ImportModalActions {
  setState: (state: Partial<ImportModalState>) => void;
  reset: () => void;
}

type ImportModalStore = ImportModalState & ImportModalActions;

export const useImportModalStore = create<ImportModalStore>()(
  devtools<ImportModalStore>((set, get) => ({
    step: 'chooseFile',
    selectedFile: null,
    remoteFileLocation: null,
    fileValidationErrors: null,

    setState: ({
      fileValidationErrors,
      remoteFileLocation,
      selectedFile,
      step,
    }) => {
      set({
        fileValidationErrors:
          fileValidationErrors === undefined
            ? get().fileValidationErrors
            : fileValidationErrors,
        remoteFileLocation:
          remoteFileLocation === undefined
            ? get().remoteFileLocation
            : remoteFileLocation,
        selectedFile:
          selectedFile === undefined ? get().selectedFile : selectedFile,
        step: step || get().step,
      });
    },

    reset: () => {
      set({
        step: 'chooseFile',
        selectedFile: null,
        remoteFileLocation: null,
        fileValidationErrors: null,
      });
    },
  }))
);
